import { Result } from '@cplug/frontend-core/utils'
import { ErrorCodes } from '@cplug/frontend-core/models'
import { AppKind, type StoreApp } from '~/domain/dashboard/app/apps/models/App'
import { CPAppGateway } from '~/domain/dashboard/app/apps/gateways/CPAppGateway'

/** Loads the store app for a company via `GET apps/store/by-company/{companyId}`. */
export async function fetchStoreAppByCompany (companyId: number): Promise<Result<StoreApp | null>> {
  const result = await CPAppGateway.instance().getStoreByCompany(companyId)

  if (!result.isOk()) {
    if (result.getError().code === ErrorCodes.NotFound) {
      return Result.ofValue(null)
    }

    return Result.ofError(result.getError())
  }

  const app = result.getValue()
  if (app.kind !== AppKind.Store) {
    return Result.ofError({ code: ErrorCodes.Unknown })
  }

  return Result.ofValue(app)
}
